import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  edd: null
};

const eddSlice = createSlice({
  name: 'edd',
  initialState,
  reducers: {
    setEddData: (state, action) => {
      state.eddData = action.payload;
    }
  }
});

export const { setEddData } = eddSlice.actions;
export default eddSlice.reducer;
